import { createApp } from 'vue';
import MortAgentsDocsWithPageNav from './vue-components/pages/mortgage-agents/MortAgentsDocsWithPageNav';
import MortAgentsFactsWithPageNav from './vue-components/pages/mortgage-agents/MortAgentsFactsWithPageNav';

const mtgAgentsDetailParent = document.querySelector('#app-parent');

if (mtgAgentsDetailParent) {
    createApp({
        components: {
            MortAgentsDocsWithPageNav,
            MortAgentsFactsWithPageNav
        }
    }).mount(mtgAgentsDetailParent);
}
